import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service'
import { __asyncDelegator } from 'tslib';

@Component({
  selector: 'app-utente',
  templateUrl: './utente.component.html',
  styleUrls: ['./utente.component.scss']
})
export class UtenteComponent implements OnInit {

  utentes: object;
  myDate: Date;
  erroLigacao: boolean = false;

  constructor(private data: DataService) { }

  ngOnInit() {
    this.myDate = new Date();
    
    this.atualizar();
  }

  private fillMarcacoes() {
    this.data.getUtentes()
      .subscribe(
        result => {
          // Handle result
          if (result['d'].length != 0) {
            this.utentes = JSON.parse(result['d']);
          }
          else { this.utentes = null; }
        },
        error => {
          this.erroLigacao = (error.status == 504);
          // console.log(error);
        },
        () => {
          // 'onCompleted' callback.
          // No errors, route to new page here
        }
      );
  }

  abrirDocumento(url: string) {
    var win = window.open(url, '_blank');
    win.focus();
  }

  atualizar() {
    this.erroLigacao = false;
    this.fillMarcacoes();
  };
}
